import { render, staticRenderFns } from "./chargeUserRank.vue?vue&type=template&id=ba19499c&scoped=true"
import script from "./chargeUserRank.vue?vue&type=script&lang=js"
export * from "./chargeUserRank.vue?vue&type=script&lang=js"
import style0 from "./chargeUserRank.vue?vue&type=style&index=0&id=ba19499c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba19499c",
  null
  
)

export default component.exports